<section class="parker-banner">
    <app-mini-env-banner [slides]="bannerSlides" (butonAction)="onSliderBtnAction()"></app-mini-env-banner>
</section>  


<section class="container-fluid discount-section">
  <div class="container">

    <app-mini-env-heading-block
        [miniTitle]="'Why Choose WoW health'"
        [title]="'Because taking care of yourself should feel easy.'"
        [description]="'Healthcare shouldn’t slow you down or add stress to your day. We remove the friction with simple access, clear guidance, and care that fits seamlessly into your routine.'"
        [style]="'max-width: 703px;'"
        ></app-mini-env-heading-block>

      <div class="row" style="row-gap: 15px;margin-top: 30px;gap: 15px;">
        <div *ngFor="let item of benefits" class="card-box col-12">
          <app-mini-env-tall-info-card 
                                  [title]="item.title"
                                  [description]="item.description"
                                  [bgImage]="item.bgImage"
                                 >
          </app-mini-env-tall-info-card>
        </div>
      </div>
  </div>
</section>

<section class="container-fluid services-section">
    <div class="container">
        
        <app-mini-env-heading-block
            [miniTitle]="'Services'"
            [title]="'Our Healthcare Services'"
            [description]="'Healthcare shouldn’t slow you down or add stress to your day. We remove the friction with simple access, clear guidance, and care that fits seamlessly into your routine.'"
            [style]="'max-width: 684px;'"
            ></app-mini-env-heading-block>

        <app-mini-env-tabs [serviceNames]="services" [imgSrc]="imgSrc" (buttonAction)="buttonAction($event)"></app-mini-env-tabs>    

    </div>
</section>

<!-- <section>
  <div class="container-fluid video-section">

     <app-mini-env-heading-block
    [miniTitle]="'See your health care in action'"
    [title]="'Let’s Dive Deep Into Understanding Wow Health'"
    [description]="'Heres a detailed video about how we make helathcare trustworthy for our WoW members'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

    <div class="container">
      <app-video-player></app-video-player>
    </div>
  </div>
</section> -->

<section class="container-fluid avail-benefits">

  <app-mini-env-heading-block
    [miniTitle]="'How it Works'"
    [title]="'Getting Started to Avail Your WoW Benefits Is Super Easy!'"
    [description]="'Follow these simple steps to start your WoW Health journey today.'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

  <app-imagebox-bullet-scroll [imgLink]="sharedService.imagesUrl + 'woman-wave-phone.webp'"></app-imagebox-bullet-scroll>
</section>

<section class="container-fluid bg-content">
  <div class="container">
    <app-mini-env-bg-content [title]="'It’s Never Too Late to Start Better With Your Health!'" 
                             [description]="'Dont wait another moment to prioritize your health. Join WoW Health now and step into a world of personalized, accessible, and affordable healthcare thats always at your fingertips.'"
                             [bgClass]="bgClass" (buttonAction)="goToMembership()"></app-mini-env-bg-content>
  </div>
</section>

<!-- <section class="container-fluid">
    <div class="container">
        <div class="tabs">

            <div class="tab-headers">
                <button
                *ngFor="let pane of panes; let i = index"
                (click)="select(i)"
                [class.active]="pane.active"
                class="tab-btn"
                >
                {{ pane.title }}
                </button>
            </div>

            <div class="tab-body">
                <div *ngFor="let pane of panes; let i = index">
                    <app-mini-env-content-box *ngIf="pane.active" [imgSrc]="imgSrc">
                        <h2 class="content-heading">{{ pane.title }}</h2>
                        <p class="content-txt">
                        Licensed Medics to guide with care decisions, with FREE virtual care.
                        </p>

                        <ul class="d-flex content-list">
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Virtual Primary Care:</span> Appointment with the same doctor - no long waiting hours.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Virtual Urgent Care:</span> 24/7 access to virtual care for non-emergency issues.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Tele counseling:</span> 24/7 Mental health and personal life support with specialists.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Message-a-specialist:</span> Quick response on medical concerns via secure chat.</li>
                        </ul>

                        <button class="btn btn-primary">Get Started</button>
                    </app-mini-env-content-box>
                </div>
            </div>

        </div>
    </div>
</section> -->

<section class="container-fluid faq-section">
  <div class="container">
    
    <app-mini-env-heading-block
    [miniTitle]="'FAQs'"
    [title]="'Frequently Asked Questions'"
    [description]="'Some questions you might have in your mind. If you couldnt find yours, call us anytime at 844-969-4325'"
    [style]="'max-width: 498px;'"
    ></app-mini-env-heading-block>

    <div class="mt-30">
       <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>  

<section class="container-fluid footer-section">
   <app-mini-env-sub-footer></app-mini-env-sub-footer>
</section>
<!--  How can we help Section End-->